import React from "react";
import { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import TextInput from "../componets/TextInput";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import DropDown from "../componets/DropDown";
import ObjectionsService from "../services/ObjectionsService";
import AddObjections from "../componets/AddObjections";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
// import EventGroupService from "../services/EventGroupService";
// import EventService from "../services/EventServices";

export const Objections = () => {
	const toast = useRef(null);
	const [showAddObjectionForm, setShowAddObjectionForm] = useState(false);
	const [objectionNumber, setObjectionNumber] = useState("");
	let [data, setData] = useState([]);

	useEffect(() => {
		// objectionTypeService.getAllObjectionType().then((data) => {
		//     setObjectionType(data);
		// });
		// objectionStatusService.getAllObjectionStatuses().then((data) => {
		//     setObjectionStatus(data);
		// });
		// eventGroupService.getAllEventGroups().then((data) => {
		//     setEventGroup(data);
		// });
	}, []);


	var objectionsService = new ObjectionsService();
	function submitForm() {
		console.log(objectionNumber);
		objectionsService.getObjectionsByID(objectionNumber).then((e) => {
			console.log(e);
			setData(e);
		});
	}
	return (


		<>
			<div className="flex" style={{ justifyContent: "space-between", alignContent: "center" }}>
				<h4>Objections</h4>
				<Button className="p-button-success mr-2" icon="pi pi-plus" label="Add Objection" onClick={(e) => setShowAddObjectionForm(true)} />
			</div>

			<AddObjections show={showAddObjectionForm} setShow={setShowAddObjectionForm} />
		</>

	);
};
